import React from 'react';
import { Alert } from '@patternfly/react-core';
import { useImpersonation } from '../../../contexts/impersonation/ImpersonationContext';
import { GPU_SERVER_IMPERSONATION_NOTICE } from './gpuServerConstants';

/**
 * Inline notice shown while a staff impersonation session is active: the backend refuses starting
 * and deleting GPU servers on a customer's behalf, so both are disabled (the pages stay readable).
 * GPU-specific on purpose — IMPERSONATION_MONEY_NOTICE's checkout sentence does not apply here.
 * Renders nothing outside an impersonation session.
 */
const GpuServerImpersonationAlert: React.FunctionComponent<{ className?: string }> = ({ className }) => {
  const { isImpersonating } = useImpersonation();
  if (!isImpersonating) {
    return null;
  }
  return (
    <Alert variant="info" isInline title="Starting and deleting are not available" className={className}>
      {GPU_SERVER_IMPERSONATION_NOTICE}
    </Alert>
  );
};

export default GpuServerImpersonationAlert;
